/** Transport errors shared by client caches, without importing UI or routing. */
export class ApiRequestError extends Error {
  constructor(message: string, readonly status: number) { super(message); this.name = 'ApiRequestError'; }
}
